import React, { useState } from 'react';
import { IconButton, Select, MenuItem } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Edit as EditIcon,
  Circle as CircleIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import moment from 'moment';
import customLocaleText from '../../constants/DataGridLocaleTextConstants.js';
import { useAuth } from '../../context/AuthContext.js';

function UsersDataGrid({ users, handleOpenDeleteModal, handleOpenModal, onSelectionChange }) {
  const [openSnackbar, setOpenSnackbar] = useState({ open: false, text: '', error: false });
  const [selectedRows, setSelectedRows] = useState([]);
  const { user } = useAuth();

  const [paginationModel] = useState({ page: 0, pageSize: 10 });

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar({ open: false, text: '', error: false });
  };

  const getDateFromTimestamp = (timestamp) => {
    if (!timestamp) return 'Fecha inválida';
    return moment.unix(timestamp).format('DD-MM-YYYY HH:mm:ss');
  };


  // Manejar selección de filas
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
    // Notificar al componente padre sobre la selección
    if (onSelectionChange) {
      onSelectionChange(newSelection);
    }
  };

  const customFilterOperators = [
    {
      label: 'Activo/Inactivo',
      value: 'isActiveFilter',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const isActive = filterItem.value === 'Activo';
        return (row) => (row === isActive);
      },
      InputComponent: ({ item, applyValue }) => (
        <Select
          value={item.value || ''}
          onChange={(event) => applyValue({ ...item, value: event.target.value })}
          style={{ width: '100%', marginTop: 'auto' }}
          data-testid="customStatusSelect"
          id="customStatusSelect"
        >
          <MenuItem value="">
            <em>--Seleccione--</em>
          </MenuItem>
          <MenuItem value={"Activo"}>Activo</MenuItem>
          <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
        </Select>
      ),
    },
  ];


  const columns = [
    {
      display: 'flex',
      field: 'is_active',
      headerName: 'Estado',
      flex: 0.08,
      filterable: true,
      filterOperators: customFilterOperators,
      renderCell: (params) => (
        <CircleIcon
          sx={{
            color: params.row.is_active ? 'green' : 'grey',
          }}
        />
      ),
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 0.25,
      filterable: true,
    },
    {
      field: 'created_at',
      headerName: 'Fecha de creación',
      valueGetter: (params) => getDateFromTimestamp(params?._seconds),
      flex: 0.2,
      filterable: true,
    },
    {
      filterable: false,
      field: 'actions',
      headerName: 'Acciones',
      flex: 0.1,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => {
        return (<>
          {user?.isAdmin ? <>
            <IconButton onClick={() => handleOpenModal(params.row)} aria-label="edit" data-testid="EditIcon">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => handleOpenDeleteModal(params.row)} aria-label="delete" data-testid="DeleteIcon">
              <DeleteIcon />
            </IconButton>
          </> : null}
        </>)
      }
    }
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '600px',
      }}
    >
      <DataGrid
        rows={users || []}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 15, 20]}
        checkboxSelection={user?.isAdmin}
        sx={{ border: 0 }}
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={handleSelectionChange}
        localeText={customLocaleText}
      />


      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={6000}
        open={openSnackbar.open}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={openSnackbar.error ? 'error' : 'success'}
          variant="filled"
        >
          {openSnackbar.text}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default UsersDataGrid;